module.exports = __webpack_public_path__ + "img/LoveIs.9af6da71.svg";